import { render, staticRenderFns } from "./AdminParticipantsWidget.vue?vue&type=template&id=527d8595"
import script from "./AdminParticipantsWidget.vue?vue&type=script&lang=js"
export * from "./AdminParticipantsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports